exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-enter-active[data-v-4120a7c6],.list-leave-active[data-v-4120a7c6]{transition:all .3s}.list-enter[data-v-4120a7c6],.list-leave-to[data-v-4120a7c6]{opacity:0;transform:translateY(-30px)}", ""]);

// exports
